import { call, put, select } from 'redux-saga/effects';
import { iActionCreate } from '~/domain/interfaces/redux/Organizer/create';
import { CreateOrganizer } from '~/domain/usecases/organizer/remote/CreateOrganizer';
import { makeRemoteCreateOrganizer } from '~/main/factories/usecases/organizer/CreateOrganizerFactory';
import {
  createSuccess,
  createFailed,
} from '~/data/store/reducer/organizer/actions/create';
import { makeReduxActiveMessage } from '~/main/factories/usecases/message/Update';
import { MessageOptions } from '~/domain/interfaces/redux/message';
import { History } from '~/main/routes';
import { closeModal } from '~/utils/closeModal';

export function* onCreate(action: iActionCreate) {
  const remoteCreateOrganizer = makeRemoteCreateOrganizer();

  try {
    const response: CreateOrganizer.Model = yield call(
      remoteCreateOrganizer.create,
      action.payload,
    );

    makeReduxActiveMessage().active({
      active: MessageOptions.userCreateSuccess,
      actionOk: () => {
        History.back();
        closeModal();
      },
    });

    yield put(
      createSuccess({
        ...response,
      }),
    );
  } catch (e) {
    yield put(createFailed());
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onCreateSuccess() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onCreateFailed() {}
